import { SiteConfig } from '../../types';
import { doc, getDoc } from 'firebase/firestore';
import { safeWrite, uploadImage } from './coreService';
import { STANDARD_SERVICES } from '../../constants';

export const fetchConfig = async (firestore: any, defaultConfig: any): Promise<SiteConfig> => {
    const configSnap = await getDoc(doc(firestore, 'site_config', 'main'));
    let config: SiteConfig;
    
    if (configSnap.exists()) {
      config = configSnap.data() as SiteConfig;
      if (!config.tariffItems) {
         config.tariffItems = STANDARD_SERVICES;
      }
    } else {
       config = { ...defaultConfig, tariffItems: STANDARD_SERVICES } as SiteConfig;
    }
    return config;
};

export const updateSiteConfig = async (
  firestore: any, 
  storage: any,
  newConfig: SiteConfig
): Promise<SiteConfig> => {
    const configToSave = JSON.parse(JSON.stringify(newConfig));

    const processGallery = async (albums: any[]) => {
      if (!albums) return [];
      for (const album of albums) {
        if (album.images) {
          for (let i = 0; i < album.images.length; i++) {
            const img = album.images[i];
            if (img.imageUrl && img.imageUrl.startsWith('data:')) {
              img.imageUrl = await uploadImage(storage, img.imageUrl, `gallery/${album.id}/${img.id}`);
            }
          }
        }
      }
      return albums;
    };

    if (configToSave.trophyGallery?.albums) {
        configToSave.trophyGallery.albums = await processGallery(configToSave.trophyGallery.albums);
    }
    if (configToSave.events?.gallery?.albums) {
        configToSave.events.gallery.albums = await processGallery(configToSave.events.gallery.albums);
    }

    if (configToSave.global.logoUrl?.startsWith('data:')) {
      configToSave.global.logoUrl = await uploadImage(storage, configToSave.global.logoUrl, 'site/logo');
    }
    
    for (const member of configToSave.familyMembers) {
      if (member.image?.startsWith('data:')) {
          member.image = await uploadImage(storage, member.image, `site/family/${member.id}`);
      }
      if (member.images) {
         for (let i = 0; i < member.images.length; i++) {
            if (member.images[i]?.startsWith('data:')) {
                member.images[i] = await uploadImage(storage, member.images[i], `site/family/${member.id}_${i}`);
            }
         }
      }
    }

    await safeWrite(doc(firestore, 'site_config', 'main'), configToSave);
    return configToSave;
};
